// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adBlockerNotification {
  top: 40px;
  width: 100%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./UI-Dash-Wrapper-UI/src/modules/FrameCollection/utils/NotificationDisplayStyles.css"],"names":[],"mappings":"AAAA;EAEI,SAAA;EACA,WAAA;EAEA,kBAAA;AADJ","sourcesContent":[".adBlockerNotification {\n\n    top: 40px;\n    width: 100%;\n\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
